module.exports = __webpack_public_path__ + "videos/beginners-series_3x4.a7deea0.mp4";